/**
 * Class util for date
 */
export default class VersionParser {

    /**
     * Parse the version name to version code (string to number)
     *
     * @param {String} versionName the version name of SDK
     * @returns {Number} the version convert to number
     */
    static parseVersion(versionName) {
        let versionNameParsed = versionName.split(".");
        if (versionNameParsed.length != 4) {
            return 0;
        }
        return this.parseVersionRec(versionNameParsed, versionNameParsed.length - 1, 1, 0);
    }

    /**
     * Recursive method to parse version
     *
     * @param {Array} versionNameSplit array contains each digits of the version name
     * @param {Number} index the index to start (from end of array)
     * @param {Number} mult the current multiplicator
     * @param {Number} result the result of previous iteration
     */
    static parseVersionRec(versionNameSplit, index, mult, result) {
        if (index >= 0) {
            return result + Number(this.parseVersionRec(versionNameSplit, index - 1, mult * 100, versionNameSplit[index] * mult))
        }
        return result;
    }

    /**
     * Returns the current timestamp in ms
     *
     * @returns {Number} Current timestamp in seconds
     */
    static getCurrentTimestampMs() {
        return Date.now();
    }
}



// WEBPACK FOOTER //
// ./js/core/utils/VersionParser.js